<template>
  <div class="home">
    <!--<img src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <float-menu
      display="X"
      event="toggle-playing"
      class="play-toggle"
      v-if="playing"
    ></float-menu>
    <float-menu
      display="⇨"
      event="load-next-game"
      v-if="playing"
    ></float-menu>
    <template v-if="playing">
      <game :game="currentGame" :mode="mode" @update-scoring='updateScoring'></game>
    </template>
    <template v-else>
      <section class="section">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2">

              <div class="content">
                <div class="has-text-centered">
                  <h1 class="title is-1 is-spaced">J! Trainer</h1>
                  <h3 class="subtitle">
                    Test your knowledge and train for your appearance by
                    playing real games with real answers from the show.
                  </h3>
                </div>

                <div class="has-text-centered">
                  <a @click="togglePlaying" class="button is-success">Start Playing!</a>

                  <h4>Controls</h4>
                  <table class="table">
                    <tr>
                      <td>Current game order:</td>
                      <td>
                        <span v-if="order === 'asc_date'">
                          Oldest to newest
                          (<a @click="switchOrder('rand')">Switch to random (requires page refresh)</a>)
                        </span>
                            <span v-if="order === 'rand'">
                          Random
                          (<a @click="switchOrder('asc_date')">Switch to oldest to newest (requires page refresh)</a>)
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>Play Mode:</td>
                      <td>
                        <span v-if="mode === 'game'">
                          Game Board
                          (<a @click="switchMode('rapidfire')">Switch to Rapid Fire</a>)
                        </span>
                        <span v-if="mode === 'rapidfire'">
                          Rapid Fire
                          (<a @click="switchMode('game')">Switch to Game Mode</a>)
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>

                <ul>
                  <li>
                    Scoring will only occur after a game is finished or skipped
                    - exiting out of an ongoing game will erase all progress
                  </li>
                  <li>
                    All stats will be stored in local storage,
                    meaning they are saved in your browser and not on a server
                  </li>
                  <li>Email mwhager87 at gmail with feedback, feature requests, and lavish praise</li>
                  <li>Also, I'm available for development work (including Python/Django and <a
                    href="https://matthiashager.com/complete-vuejs-application-tutorial">Vue.js</a>),
                    projects, free food, and talking about tea.
                  </li>
                  <li>Read more about <a href="http://www.j-archive.com/help.php#coryatscore" target="_blank">Coryat
                    score</a> and <a href="http://www.pisspoor.com/jep.html" target="_blank">how to win on Jeopardy!</a>
                  </li>
                </ul>

                <div v-if="scoring">
                  <h4>Your Accumulated Stats</h4>
                  <table class="table">
                    <tr>
                      <td>
                        Games Played
                      </td>
                      <td>
                        {{ scoring.gamesPlayed }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Correct Responses
                      </td>
                      <td>
                        {{ scoring.totalCorrect }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Incorrect Responses
                      </td>
                      <td>
                        {{ scoring.totalIncorrect }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Revealed Questions
                      </td>
                      <td>
                        {{ scoring.totalRevealed }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Score (Coryat)
                      </td>
                      <td>
                        {{ scoring.totalCoryat }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Possible Score (Coryat)
                      </td>
                      <td>
                        {{ scoring.totalPossibleCoryat }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Score %
                      </td>
                      <td>
                        {{ scoring.totalPossibleCoryat ? (scoring.totalCoryat / scoring.totalPossibleCoryat *
                        100).toFixed(2) : 0}}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Live Score (Coryat)
                      </td>
                      <td>
                        {{ scoring.totalLiveCoryat }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Live %
                      </td>
                      <td>
                        {{ scoring.totalPossibleCoryat ? (scoring.totalLiveCoryat / scoring.totalPossibleCoryat *
                        100).toFixed(2) : 0 }}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Revealed Possible Score (Coryat)
                      </td>
                      <td>
                        {{ scoring.totalRevealedCoryat }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Revealed Coryat %
                      </td>
                      <td>
                        {{ scoring.totalRevealedCoryat ? (scoring.totalCoryat / scoring.totalRevealedCoryat *
                        100).toFixed(2) : 0 }}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Correct Final Jeopardy
                      </td>
                      <td>
                        {{ scoring.fjCorrect }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Incorrect Final Jeopardy
                      </td>
                      <td>
                        {{ scoring.fjIncorrect }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Revealed Final Jeopardy
                      </td>
                      <td>
                        {{ scoring.fjRevealed }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Revealed FJ %
                      </td>
                      <td>
                        {{ scoring.fjRevealed ? (scoring.fjCorrect / scoring.fjRevealed * 100).toFixed(2) : 0 }}%
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Total Passed Coryat %
                      </td>
                      <td>
                        {{ scoring.totalPassedCoryat ? (scoring.totalPassedCoryat / scoring.totalPossibleCoryat *
                        100).toFixed(2) : 0 }}%
                      </td>
                    </tr>

                  </table>
                </div>

                <div>
                  <h4>Roadmap</h4>
                  <ul>
                    <li>
                      <del>Keyboard commands</del>
                    </li>
                    <li>Improved mobile appearance</li>
                    <li>Jump to play specific airdates</li>
                    <li>Automatically add new games (most recent game 2018-07-24)</li>
                    <li>Mobile app?</li>
                    <li>Play along with live games?</li>
                    <li>Death metal J! theme music?</li>
                    <li>Time limits for answering</li>
                    <li>Key commands for cycling rounds, games</li>
                    <li>More elaborate statistics</li>
                    <li>Review / replay past games?</li>
                    <li>Compare your Coryat scores against other players (possibly)</li>
                    <li>2018-09-13: <del>Rapid-fire play mode</del></li>
                    <li>2018-08-14: <del>Skip answering after a question is revealed (i.e. don't buzz in)</del></li>
                  </ul>

                  <h4>Key Commands</h4>
                  <ul>
                    <li>Up/Down/Left/Right to navigate clues</li>
                    <li>Enter to select the clue, and to swap from answer to question</li>
                    <li>After answering: Enter to mark correct, X to mark incorrect</li>
                    <li>Space to pass or continue</li>
                  </ul>

                  <small class="has-text-centered"><em>
                    The Jeopardy! game show and all elements thereof,
                    including but not limited to copyright and trademark thereto,
                    are the property of Jeopardy Productions, Inc. and are protected
                    under law. This website is not affiliated with, sponsored by, or
                    operated by Jeopardy Productions, Inc.
                  </em></small>

                  <small class="has-text-centered"><em>
                    Built by <a href="https://matthiashager.com/">Matthias Hager</a>
                  </em></small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
  // @ is an alias to /src
  // import HelloWorld from '@/components/HelloWorld.vue';
  import EventBus from '@/EventBus';
  import emptyScoring from '@/emptyscoring';
  import Game from '@/components/Game.vue';
  import FloatMenu from '@/components/FloatMenu.vue';

  // import games from '@/data/games-0-1000.json';

  export default {
    name: 'home',
    components: {
      // HelloWorld,
      Game,
      FloatMenu,
    },

    data() {
      return {
        playing: false,
        currentGameId: null,
        currentGame: null,
        games: {},
        gamesPlayed: {},
        scoring: Object.assign({}, emptyScoring),
        order: 'asc_date',
        mode: 'game',
      };
    },

    created() {
      this.$local.keys().then((keys) => {
        if (keys.includes('version')) {
          this.$local.getItem('version').then((v) => {
            if (v < process.env.VUE_APP_RELEASE) {
              // database out of date, we'd do fancy things here to fix that then
              this.saveAppVersion();
            }
          });
        } else {
          // no app version saved, let's fix that
          this.saveAppVersion();
        }

        // TODO: this whole section is really ugly w/ lots of async calls, fix it!
        if (keys.includes('maxGame')) {
          // legacy code - backfill any games played if user visited before changed to tracking
          // games; then remove maxGame
          this.$local.getItem('maxGame').then((maxGame) => {
            // maxGame was actually the NEXT game to be played, so we'll backfill
            // but not include it
            let d = new Date(maxGame);
            d.setDate(d.getDate() - 1);
            console.log(maxGame);

            this.$http.get(`games/${d.toISOString().slice(0, 10)}/10/`).then((res) => {
              this.games = Object.assign({}, this.games, res.data);
              this.currentGameId = Object.keys(res.data)[0];
              this.currentGame = this.games[this.currentGameId];
              EventBus.$emit('new-game');
              EventBus.$on('load-next-game', this.loadNextGame);
            });

            // TODO: backfill games played...
            // otherwise if a player loads the page and switches to new version, but does not play a game
            // their progress will be reset...
            // I'm actually not too worried about this, not many players at this point... this whole migration
            // code is likely meaningless, no need to backfill this stuff and write extra code...

            this.$local.setItem('order', 'asc_date');
            this.$local.removeItem('maxGame');
          });
        } else {
          this.$local.getItem('order').then((order) => {
            if (order) this.order = order;

            if (this.order === 'asc_date') {
              this.$local.getItem('gamesPlayed').then((gamesPlayed) => {
                let lastGame = '1983-09-17'; // first game 1983-09-18
                if (gamesPlayed) {
                  this.gamesPlayed = gamesPlayed;
                  const gamesArr = Object.keys(this.gamesPlayed);
                  lastGame = gamesArr[gamesArr.length - 1];
                }

                this.$http.get(`games/${lastGame}/5/`).then((res) => {
                  // new obj so Vue can see the changes
                  this.games = Object.assign({}, this.games, res.data);
                  this.currentGameId = Object.keys(res.data)[0];
                  this.currentGame = this.games[this.currentGameId];
                  EventBus.$emit('new-game');
                  EventBus.$on('load-next-game', this.loadNextGame);
                });
              });
            } else {
              this.$http.get(`games/5/${this.order}/`).then((res) => {
                // new obj so Vue can see the changes
                this.games = Object.assign({}, this.games, res.data);

                this.$local.getItem('gamesPlayed').then((gamesPlayed) => {
                  if (gamesPlayed) this.gamesPlayed = gamesPlayed;

                  // this is sort of naive right now, it assumes out of the games loaded
                  // at least 1 of them will be unplayed; needs to be improved
                  for (const key in this.games) {
                    if (!(key in this.gamesPlayed)) {
                      // found our first game that has not been played, load it
                      this.currentGameId = key;
                      this.currentGame = this.games[this.currentGameId];
                      EventBus.$emit('new-game');
                      // this.queueGames(); // no need since we loaded extra games already
                      EventBus.$on('load-next-game', this.loadNextGame);
                      break;
                    }
                  }
                });
              });
            }
          });
        }

        if (keys.includes('mode')) {
          this.$local.getItem('mode').then((mode) => {
            this.mode = mode;
          });
        }
      });
      // this.$local.getItem('maxGame').then((val) => {
      //   // earliest air date of 1983-09-18
      //   this.currentGameId = val || this.currentGameId || '1983-09-18';
      //
      //   this.$http.get(`game/${this.currentGameId}/`).then((res) => {
      //     // new obj so Vue can see the changes
      //     this.games = Object.assign({}, this.games, res.data);
      //     this.currentGame = this.games[this.currentGameId];
      //     EventBus.$emit('new-game');
      //     this.queueGames();
      //     EventBus.$on('load-next-game', this.loadNextGame);
      //   });
      // });

      this.$local.getItem('scoring').then((val) => {
        // uses this.scoring as template and any properties in val will be copied to and overwrite
        // default scoring, allowing new props to be added later w/o NaN issues
        this.scoring = Object.assign(this.scoring, val);
      });

      EventBus.$on('toggle-playing', this.togglePlaying);
    },

    methods: {
      saveAppVersion() {
        this.$local.setItem('version', process.env.VUE_APP_RELEASE);
      },

      togglePlaying() {
        if (this.playing) {
          if (!confirm('Quitting an active game will reset your answers and the score will not be recorded. Are you sure you want to quit?')) {
            return;
          }
        }

        this.playing = !this.playing;
      },

      queueGames() {
        const count = 5;

        return this.$http.get(`game/${this.currentGameId}/${count}/`).then((res) => {
          this.games = Object.assign({}, this.games, res.data);
        });
      },

      loadNextGame() {
        const count = 3;

        // TODO: probably don't want to store the whole game like this in localstorage...
        this.gamesPlayed[this.currentGameId] = this.currentGame;

        if (this.currentGameIndex + 1 < this.gameIndex.length) {
          this.currentGameId = this.gameIndex[this.currentGameIndex + 1];
          this.currentGame = this.games[this.currentGameId];
          this.saveGamesPlayed();
          EventBus.$emit('new-game');
        }

        if (this.currentGameIndex > (this.gameIndex.length - count)) {
          this.queueGames();
        }
      },

      saveGamesPlayed() {
        // TODO: better storage here...
        this.$local.setItem('gamesPlayed', this.gamesPlayed);
      },

      updateScoring(scoring) {
        // TODO: track Round 1 Row 1 Col 1 scoring
        // R1R1C1, i.e. $200 clue (old games $100)
        // this doesn't actualyt work because cols are not currently ordered
        // TODO: track final
        Object.entries(scoring).forEach(([k, v]) => {
          console.log(this.scoring);
          if (!(k in this.scoring)) {
            this.scoring[k] = v; // ensures we don't get NaN errors when adding new scoring criteria
            console.log('adding ', k);
          } else {
            this.scoring[k] += v;
          }
        });

        this.$local.setItem('scoring', this.scoring);
      },

      switchOrder(order) {
        this.order = order;
        this.$local.setItem('order', order);
      },

      switchMode(mode) {
        this.mode = mode;
        this.$local.setItem('mode', mode);
      },
    },

    computed: {
      gameIndex() {
        return Object.keys(this.games).sort();
      },

      currentGameIndex() {
        return this.gameIndex.indexOf(this.currentGameId);
      },
    },
  };
</script>

<style scoped lang="scss">
  .play-toggle {
    right: auto !important;
    left: 2%;
  }
</style>
